import { ACCOMMODATION_VALUE } from '@/shared/types/basic.ts';

import { useI18n } from '@experience/i18n';
import ru from '../i18n/ru.json';

export const getAccommodationFilterItems = () => {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  return {
    HOTEL_3: {
      label: t('hotel_3'),
      description: '',
      value: ACCOMMODATION_VALUE.HOTEL_3,
    },
    HOTEL_4_5: {
      label: t('hotel_4_5'),
      description: '',
      value: ACCOMMODATION_VALUE.HOTEL_4_5,
    },
    APARTMENTS: {
      label: t('apartments'),
      description: '',
      value: ACCOMMODATION_VALUE.APARTMENTS,
    },
    GUEST_HOUSE: {
      label: t('guest_house'),
      description: '',
      value: ACCOMMODATION_VALUE.GUEST_HOUSE,
    },
    COTTAGE: {
      label: t('cottage_villa'),
      description: '',
      value: ACCOMMODATION_VALUE.COTTAGE,
    },
    CAMPING: {
      label: t('camping'),
      description: '',
      value: ACCOMMODATION_VALUE.CAMPING,
    },
    GLAMPING: {
      label: t('glamping'),
      description: '',
      value: ACCOMMODATION_VALUE.GLAMPING,
    },
    HOTEL_2: {
      label: t('hotel_2'),
      description: '',
      value: ACCOMMODATION_VALUE.HOTEL_2,
    },
    SPA_HOTEL: {
      label: t('spa_hotel'),
      description: '',
      value: ACCOMMODATION_VALUE.SPA_HOTEL,
    },
    UNIQUE: {
      label: t('unique'),
      description: t('unique_description'),
      value: ACCOMMODATION_VALUE.UNIQUE,
    },
    YACHT_SHIP: {
      label: t('yacht_ship'),
      description: '',
      value: ACCOMMODATION_VALUE.YACHT_SHIP,
    },
    TRAIN: {
      label: t('train'),
      description: '',
      value: ACCOMMODATION_VALUE.TRAIN,
    },
    NOT_SET: {
      label: t('notSet'),
      description: '',
      value: ACCOMMODATION_VALUE.NOT_SET,
    },
  };
};
